export default "/images/help-hook-show.png?72ef5e9050b30f02bcbe6a8a464b07de";